import React from 'react';
import AuthorsList from './AuthorsList';
import { withRouter, Link } from 'react-router-dom';
var getTitleContent = function getTitleContent(tipoOrigem, tituloCapitulo, tituloDeT, tituloArtigo) {
  switch (tipoOrigem) {
    case 'capitulo':
      if (!!tituloCapitulo) return tituloCapitulo;
      break;
    case 'artigo':
      if (!!tituloArtigo) return tituloArtigo;
      break;
    case 'diagnostico_e_tratamento':
      if (!!tituloDeT) return tituloDeT;
      break;
  }
};
var ContentImageExample = function ContentImageExample(_ref) {
  var content = _ref.content,
    handleAuthorClick = _ref.handleAuthorClick,
    _ref$ReadingTimeIconC = _ref.ReadingTimeIconComponent,
    ReadingTimeIconComponent = _ref$ReadingTimeIconC === undefined ? null : _ref$ReadingTimeIconC;
  var _content$titulo = content.titulo,
    titulo = _content$titulo === undefined ? '' : _content$titulo,
    _content$descricao = content.descricao,
    descricao = _content$descricao === undefined ? '' : _content$descricao,
    _content$url = content.url,
    url = _content$url === undefined ? '' : _content$url,
    _content$autores = content.autores,
    autores = _content$autores === undefined ? [] : _content$autores,
    _content$origemId = content.origemId,
    origemId = _content$origemId === undefined ? '' : _content$origemId,
    _content$tipo = content.tipo,
    tipo = _content$tipo === undefined ? '' : _content$tipo,
    _content$tituloCapitu = content.tituloCapitulo,
    tituloCapitulo = _content$tituloCapitu === undefined ? '' : _content$tituloCapitu,
    _content$tituloDeT = content.tituloDeT,
    tituloDeT = _content$tituloDeT === undefined ? '' : _content$tituloDeT,
    _content$tituloArtigo = content.tituloArtigo,
    tituloArtigo = _content$tituloArtigo === undefined ? '' : _content$tituloArtigo,
    _content$tipoOrigem = content.tipoOrigem,
    tipoOrigem = _content$tipoOrigem === undefined ? '' : _content$tipoOrigem,
    _content$minutosLeitu = content.minutosLeitura,
    minutosLeitura = _content$minutosLeitu === undefined ? '' : _content$minutosLeitu;
  var tituloConteudo = getTitleContent(tipoOrigem, tituloCapitulo, tituloDeT, tituloArtigo) || '';
  return React.createElement('div', {
    className: 'container'
  }, React.createElement('h1', null, titulo), React.createElement(AuthorsList, {
    values: autores,
    handleClick: handleAuthorClick
  }), minutosLeitura && React.createElement('p', {
    style: {
      marginTop: '-40px',
      marginBottom: '30px'
    }
  }, ReadingTimeIconComponent && React.createElement(ReadingTimeIconComponent, {
    style: {
      width: '1rem',
      verticalAlign: 'middle',
      marginLeft: 5,
      marginRight: 3
    }
  }), ' ', minutosLeitura, ' min de leitura'), origemId && React.createElement('p', {
    style: {
      marginBottom: 32
    }
  }, 'Veja o conte\xFAdo completo:', React.createElement(Link, {
    style: {
      marginLeft: 10
    },
    to: '/conteudo/' + origemId
  }, tituloConteudo)), url && React.createElement('img', {
    src: url,
    alt: titulo
  }), React.createElement('div', {
    className: 'texto'
  }, descricao));
};
export default withRouter(ContentImageExample);